(function (angular) {
	'use strict';

	angular
		.module('settingsModule')
		.controller('GenericSettings', [
			'globalConfig',
			GenericSettingsFunction
		]);

	function GenericSettingsFunction(globalConfig) {
		var settings = this;

		angular.merge(settings, globalConfig);
	}
})(window.angular);